import React from 'react';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { ApplicantList } from 'components';
import { useLocalErrorHandler } from 'hooks';

const AcQualificationContainer = ({
    setErrorHandler, getApplicantList, apiError, applicantList, onPush, isAsc,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [processing, setProcessing] = React.useState(false);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await getApplicantList({});
            setProcessing(false);
        };

        fetch();
    }, []);


    const handleApplicantSelect = (id: string) => {
        onPush(`/applicant-details/${id}/info`);
    };

    return (
        <ApplicantList
          cardCategory={`Список всех аккредитуемых, связанных с ${isAsc ? 'АПК' : 'АК'}`}
          getList={getApplicantList}
          handleApplicantSelect={handleApplicantSelect}
          applicantList={applicantList}
          apiError={apiError}
          processing={processing}
          filters={{}}
          placeholderTitle="Никого нет в списке"
          placeholderText={`Здесь будут отображаться все аккредитуемые, связанные с вашей ${isAsc ? 'АПК' : 'АК'}`}
        />
    );
};

const mapState = (state: IRootState) => ({
    applicantList: state.applicants.applicantList,
    apiError: state.errors.error,
    isAsc: state.auth.isAsc,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getApplicantList: dispatch.applicants.getApplicantListAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(AcQualificationContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
